module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Gc-Da-Eb.93795e83.png";